<template>
  <v-footer absolute app class="footer" color="cmf_blue">
    <div class="footer-inner">
      <div class="footer__first">
        <div class="footer-logo">
          <a href="https://campusmoviefiest.com/" target="_blank"></a>
        </div>
        <a
          class="footer-terminus"
          href="https://campusmoviefest.com/terminus/about"
          aria-label="CMF Terminus"
        ></a>
        <a
          class="footer-cannes"
          href="https://campusmoviefest.com/cannes"
          aria-label="CMF Cannes"
        ></a>
        <a
          class="footer-newsletter"
          href="https://campusmoviefest.com/newsletter"
          >Newsletter</a
        >
      </div>
      <div class="footer__tweets">
        <div class="footer__twitter-wrapper">
          <TwitterFeed
            class="twitter-timeline"
            src="https://twitter.com/campusmoviefest?ref_src=twsrc%5Etfw"
            dark
            data-width="300"
            data-height="200"
            data-theme="dark"
          ></TwitterFeed>
        </div>
      </div>
      <div class="footer__insta">
        <div class="footer__insta-wrapper">
          <iframe
            id="lightwidget_f7ab60ab48.lightwidget-widget"
            allowtransparency="true"
            name="lightwidget_f7ab60ab48"
            scrolling="no"
            src="//lightwidget.com/widgets/f7ab60ab48d6503089080bc92d88a57e.html"
            style="width: 100%; border: 0; overflow: hidden"
          ></iframe>
        </div>
      </div>
      <div class="footer__last">
        <div class="footer__socials">
          <a
            class="footer__social"
            target="_blank"
            v-for="social in socials"
            :key="social.alt"
            :href="social.url"
          >
            <v-icon size="17" :alt="social.alt" color="white">{{
              `mdi-${social.icon}`
            }}</v-icon>
          </a>
        </div>
        <div class="footer-actions">
          <a
            href="https://campusmoviefest.com/contact"
            class="footer-actions__menu-item"
            >Contact</a
          >
          <a
            href="https://campusmoviefest.com/news"
            class="footer-actions__menu-item"
            >News</a
          >
          <a
            href="https://campusmoviefest.com/legal"
            class="footer-actions__menu-item"
            >Legal</a
          >
          <a
            href="https://jobs.lever.co/ideasunited?department=Education&team=Campus%20Movie%20Fest"
            target="_blank"
            class="footer-actions__menu-item"
            >Work With Us</a
          >
        </div>
        <div class="footer-copyright">
          Ideas United, LLC. © {{ new Date().getFullYear() }}
          <br />
          <a href="https://campusmoviefest.com/privacy">Privacy Policy</a>
          <br />
          <a href="https://campusmoviefest.com/terms">Terms and Conditions</a>
        </div>
      </div>
    </div>
    <EmailSubscribeModal v-model="subscribeModal" />
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      socials: [
        {
          url: "https://www.instagram.com/campusmoviefest",
          icon: "instagram",
          alt: "instagram"
        },
        {
          url: "https://www.twitter.com/campusmoviefest",
          icon: "twitter",
          alt: "twitter"
        },
        {
          url: "https://www.facebook.com/campusmoviefest",
          icon: "facebook",
          alt: "facebook"
        },
        {
          url: "https://www.youtube.com/campusmoviefest",
          icon: "youtube",
          alt: "youtube"
        }
      ],
      subscribeModal: false
    };
  },
  methods: {
    toTop() {
      window.scrollTo(0, 0);
    }
  },
  mounted() {
    if (
      !localStorage.subscribeModalSeen ||
      localStorage.subscribeModalSeen < 2
    ) {
      this.subscribeModal = true;
      if (!localStorage.subscribeModalSeen) localStorage.subscribeModalSeen = 1;
      else localStorage.subscribeModalSeen++;
    }
  }
};
</script>

<style scoped lang="scss">
.footer {
  min-height: 250px;
  padding: 35px 120px 20px;
  &-inner {
    height: 100%;
    width: 100%;
    margin: 0;

    display: flex;
    align-items: stretch;
    justify-content: space-between;

    > div {
      flex-basis: 25%;
    }
  }

  &__first {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: flex-start;
    display: flex !important;
    justify-content: space-between;
  }

  &-logo {
    display: flex;
    align-items: center;

    width: 240px;
    height: 24px;
    background-image: url("~@/assets/logo_footer.svg");
    background-size: contain;
    background-position: center center;
    transition: 0.3s;
  }

  &-terminus,
  &-cannes {
    display: block;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
  }

  &-terminus {
    width: 153px;
    height: 35px;
    background-image: url("~@/assets/footer_terminus.svg");
  }

  &-cannes {
    width: 125px;
    height: 35px;
    background-image: url("~@/assets/footer_cannes.svg");
  }

  &-newsletter {
    background-color: white;
    color: $primary !important;
    font-weight: 400;
    font-size: 18px;
    text-transform: uppercase;
    padding: 4px 20px;
    text-decoration: none;
    letter-spacing: 0.167em;
  }

  &__tweets,
  &__insta {
    min-width: 300px;
  }
  &__tweets {
    margin: 0 2px 0 40px;
  }
  &__insta {
    margin: 0 40px 0 2px;
  }

  &__insta-wrapper {
    height: 200px;
    width: 300px;
    overflow: hidden;
    > iframe {
      height: 100%;
    }
  }

  &__last {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  &__socials {
    display: flex;
    justify-content: space-between;
  }

  &__social {
    margin-right: 20px;
    text-decoration: none;
    &:last-child {
      margin-right: 0;
    }
  }

  &-actions {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin: 15px 0;

    &__menu-item {
      display: inline-block;
      color: white;
      font-weight: 500;
      font-size: 18px;
      line-height: 1;
      letter-spacing: 0.167em;
      text-transform: uppercase;
      text-decoration: none;
      transition: 0.3s;
      border-bottom: 1px solid transparent;
      margin-bottom: 0.5em;
      text-align: right;
      white-space: nowrap;

      &:active {
        border-color: $primary;
      }

      &:hover {
        text-decoration: underline;
      }
    }
  }

  &-copyright {
    font-size: 12px;
    color: $primary;
    text-align: right;
  }

  &::v-deep {
    .theme--light.v-btn,
    .v-btn {
      font-weight: 600;
      text-transform: none;
      letter-spacing: -0.02em;
      border-radius: none;
      color: #ffffff !important;
    }
  }
}
.theme--light.v-footer {
  background: white;
}

a.footer-logo__append {
  text-decoration: none;
}

.subscribe-btn {
  justify-content: space-between;
  margin-top: 5px;
}
@media screen and (max-width: 960px) {
  .footer {
    padding: 35px 56px 20px;

    &-inner {
      flex-wrap: wrap;
      > div {
        flex-basis: 50%;
        margin: 0 0 30px;
      }
    }
  }
}

@media screen and (max-width: 960px) {
  .footer {
    height: unset;
    position: relative;
    padding: 20px 20px 17px 20px;
    &-inner > div {
      margin-bottom: 30px;
      flex-basis: 100%;
    }
    &__tweets {
      margin-left: 0;
    }
    &__insta {
      margin-right: 0;
    }
    &__first {
      border-bottom: none;
      height: unset;
      min-height: 200px;
    }
    &__last {
      min-height: 200px;
      margin-bottom: 30px;
      flex-basis: 100%;
    }
    &-logo {
      align-items: center;
    }
  }
}
</style>
